import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as votesApi from '../api/votes';

export const useMyVote = (gameId, roundId) => {
  return useQuery({
    queryKey: ['vote', gameId, roundId],
    queryFn: () => votesApi.getMyVote(gameId, roundId),
    enabled: !!gameId && !!roundId,
  });
};

export const useCastVote = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (mvpUserId) => votesApi.castVote(gameId, roundId, mvpUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['vote', gameId, roundId] });
      queryClient.invalidateQueries({ queryKey: ['voting-status', gameId, roundId] });
    },
  });
};

export const useVotingStatus = (gameId, roundId) => {
  return useQuery({
    queryKey: ['votingStatus', gameId, roundId],
    queryFn: () => votesApi.getVotingStatus(gameId, roundId),
    enabled: !!gameId && !!roundId,
    // Real-time updates via WebSocket (useGameSocket hook)
  });
};

export const useVotingResults = (gameId, roundId, options = {}) => {
  return useQuery({
    queryKey: ['voting-results', gameId, roundId],
    queryFn: () => votesApi.getVotingResults(gameId, roundId),
    enabled: !!gameId && !!roundId && options.enabled !== false,
  });
};

export const useVotableParticipants = (gameId, roundId) => {
  return useQuery({
    queryKey: ['votable-participants', gameId, roundId],
    queryFn: () => votesApi.getVotableParticipants(gameId, roundId),
    enabled: !!gameId && !!roundId,
  });
};
